import React, { useEffect } from 'react';
import { object, string } from 'prop-types';
import AppApolloConsumer from './ApolloConsumer';
import LOG_MODULE_ACCESS from '../../queries/LOG_MODULE_ACCESS';

const LogOnMount = ({ module, client }) => {
    useEffect(() => {
        if (!client || !module) return undefined;
        client.mutate({
            mutation: LOG_MODULE_ACCESS,
            variables: {
                input: { module }
            }
        }).catch(error => console.error(`[ModuleAccessLogger] ${module}:`, error));
        return undefined;
    }, []);
    return null;
};

const ModuleAccessLogger = ({ module }) => (
    <AppApolloConsumer>
        {({ client }) => (
            <LogOnMount
                module={module}
                client={client}
            />
        )}
    </AppApolloConsumer>
);

LogOnMount.propTypes = {
    module: string,
    client: object
};

ModuleAccessLogger.propTypes = {
    module: string.isRequired
};

export default ModuleAccessLogger;
